import { request } from '@umijs/max';

export const login = async (params: API.LoginParams) => {
  return request('/user/login', {
    method: 'POST',
    data: params,
  });
};

export const logout = async () => {
  return request('/user/logout', {
    method: 'GET',
  });
};

export const queryCurrentUser = async () => {
  // return {
  //   status: 0,
  //   data: {
  //     content: {
  //       id: '1',
  //       name: '张三',
  //       avatar: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //     },
  //   },
  // };
  return request('/member/get-current-user-info', {
    method: 'GET',
  });
};
